import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { BaseDirective } from '../../../base.directive';
@Component({
    selector: 'eui-table-filter',
    templateUrl: './eui-table-filter.component.html',
})

export class EuiTableFilterComponent extends BaseDirective implements OnInit, OnDestroy {
    @Input() placeholder: string;

    @Input()
    get autoSearch() { return this._autoSearch; }
    set autoSearch(value) { this._autoSearch = coerceBooleanProperty(value); }
    _autoSearch = false;

    @Output() filterChange = new EventEmitter<string>();

    @ViewChild('filterInput') filterInput: ElementRef<HTMLInputElement>;

    public filter$: BehaviorSubject<string | null> = new BehaviorSubject(null);
    public form: FormGroup;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-table__filter'),
        ].join(' ').trim();
    }

    constructor(private fb: FormBuilder) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            filter: new FormControl(null),
        });

        this.form.get('filter').valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            takeUntil(this.destroy$),
        ).subscribe((value) => {
            this.setFilter(value);
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    public setFilter(value: string) {
        this.filter$.next(value);
        this.filterChange.emit(value);
    }

    public resetFilter() {
        this.setFilter(null);
        this.form.reset();
        this.filterInput.nativeElement.focus();
    }
}
